import React, { useState, ReactNode } from 'react';
import { useAutoSave } from '@/hooks/useAutoSave';
import { SaveIndicator } from './SaveIndicator';
import { SaveStatus } from '@/types/common';

interface AutoSaveFormProps<T> {
    onSave: (data: T) => Promise<void>;
    children: ReactNode;
    className?: string;
}

export function AutoSaveForm<T>({ 
    onSave, 
    children,
    className 
}: AutoSaveFormProps<T>) {
    const [saveStatus, setSaveStatus] = useState<SaveStatus>({ status: 'idle' });

    const autoSave = useAutoSave({
        onSave,
        onStatusChange: setSaveStatus,
        onError: (error) => {
            console.error('Auto-save error:', error);
        }
    });

    return (
        <div>
            <div className="mb-4 flex justify-end">
                <SaveIndicator status={saveStatus} />
            </div>
            <div className={className}>
                <form onChange={(e) => {
                    const formData = new FormData(e.currentTarget);
                    const data = Object.fromEntries(formData.entries()) as unknown as T;
                    autoSave(data);
                }}
                onInput={(e) => {
                    // Capturar também eventos input para garantir que mudanças programáticas sejam detectadas
                    const formData = new FormData(e.currentTarget);
                    const data = Object.fromEntries(formData.entries()) as unknown as T;
                    autoSave(data);
                }}>
                    {children}
                </form>
            </div>
        </div>
    );
}
